import axios from "axios";
import { LoginRequest, LoginResponse } from "./LoginForm";
import { MfaRequest, MfaResponse } from "./LoginForm";
import { PasswordReminderRequest, PasswordReminderResponse } from "./LoginForm";
import { PasswordUrlCheckRequest, PasswordUrlCheckResponse } from "./LoginForm";
import { PasswordResetRequest, PasswordResetResponse } from "./LoginForm";
import { AxiosResponse } from "axios";
import { ApplicationApi, ApplicationProtectedRouting, ApplicationPublicRouting } from "../../../Routing";

/**
 * ログイン API
 */
export class LoginService {
  // ログインAPI
  login = async (param: LoginRequest): Promise<LoginResponse> => {
    try {
      const res: AxiosResponse<LoginResponse> = await axios.post(
        ApplicationPublicRouting.login.apiUrl(),
        param
      );
      return res.data;
    } catch (err) {
      throw err;
    }
  };

  // ログアウトAPI
  logout = async (param: LoginRequest): Promise<LoginResponse> => {
    try {
      const res: AxiosResponse<LoginResponse> = await axios.post(
        ApplicationApi.logout.apiUrl(),
        param
      );
      return res.data;
    } catch (err) {
      throw err;
    }
  };
}
